module.exports = __webpack_public_path__ + "static/media/lixeira.e46e9d54.svg";